import React from "react";

const Contact = () => {
  return (
    <div className="contact-container">
      <h2>Contact Me</h2>
      <p>
        Email:{" "}
        <a
          href="mailto:MandiSolone@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          MandiSolone@gmail.com
        </a>
      </p>
      <p>
        LinkedIn:{" "}
        <a
          href="https://www.linkedin.com/in/mandi-solone-8a301647/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn.com/in/Mandi-Solone
        </a>
      </p>
      <p>
        GitHub:{" "}
        <a
          href="https://github.com/MandiSolone"
          target="_blank"
          rel="noopener noreferrer"
        >
          Github.com/MandiSolone
        </a>
      </p>
      <p>
        Clearwater, FL
        <br />
        United States
      </p>
    </div>
  );
};

export default Contact;
